
export const BACKGROUND_COLOR_HEX = "#8bac0f"
export const FOREGROUND_COLOR_HEX = "#306230"
